import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import icAccountCircle from '@iconify/icons-ic/twotone-account-circle';
import { PopoverRef } from '../../../../components/popover/popover-ref';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { User } from '../../../../../app/models/user/user.model';

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarUserDropdownComponent implements OnInit {
  userDetail: User;
  icAccountCircle = icAccountCircle;

  constructor(
    private popoverRef: PopoverRef<User>,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.getUserData();
  }

  getUserData() {
    this.userDetail = this.popoverRef.data;
  }

  close() {
    this.popoverRef.close();
  }

  logout() {
    this.close();
    this.authService.logout();
  }
}
